<template>
 <div id="page-content" ref="list-top">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div v-if="loading" class="page-loader-inline">
            <div class="loading-spinner-wrap">
              <div class="loading-spinner"></div>
              <div class="loading-spinner-inner"></div>
            </div>
            <p>載入中...</p>
          </div>
          <school-list-view
            v-if="display=='LIST' && !loading"
            :loading="loading"
            :pagedItems="pagedItems"
            :level="level"
            :total="total"
            :currentPage="currentPage"
            :perPage="perPage"
            :model="filterModel"
            :category="category"
            @sortFromView="setSortFromView($event, arguments[1])"
            @pageChange="changePage($event)"
            @showDetails="storeStatus('schools')"
            @filterOnChange="handleFilterChange"
            @reset="handleReset">
          </school-list-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import * as mixin from './SchoolListMixin.vue';
    let schoolList = Vue.extend({
        mixins:[mixin],
        data() {
            return {
                filterModel: {
                    keyword: '',
                    districts: {},
                    religious: {},
                    financeTypes: {},
                    genders: {}
                }
            };
        },
        methods: {
            changePage(page) {
                this.currentPage = page;
                this.setPage(page);
            },
            handleFilterChange(model) {
                this.filterModel = model;
                this.model = model;
                this.filter();
            },
            handleReset() {
                this.filterModel = {
                    keyword: '',
                    districts: {},
                    religious: {},
                    financeTypes: {},
                    genders: {}
                };
                this.reset();
            }
        }
    });
    export default schoolList;
</script>



// WEBPACK FOOTER //
// resources/js/school/SchoolList.vue